export default "__VITE_ASSET__BQt50VeL__"